import React from 'react';
// import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl';
import { Td, Row } from '@layout/ParticipantsTable';
import messages from './messages';

const ParticipantsTableHead = ({ order, sortBy }) => (
  <thead>
    <Row>
      <Td padding="15px" width="5%" primary />
      <Td primary>
        <FormattedMessage {...messages.name} />
      </Td>
      <Td primary>
        <FormattedMessage {...messages.type} />
      </Td>
      <Td primary>
        <FormattedMessage {...messages.phone} />
      </Td>
      <Td primary>
        <FormattedMessage {...messages.country} />
      </Td>
    </Row>
  </thead>
);

ParticipantsTableHead.propTypes = {};

ParticipantsTableHead.defaultProps = {};

export default ParticipantsTableHead;



// WEBPACK FOOTER //
// ./components/organisms/ParticipantsTable/ParticipantsTableHead.js